import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "chat-dialog__logo" }
const _hoisted_2 = {
  key: 0,
  class: "chat-dialog__logo-img",
  alt: "Avatar"
}
const _hoisted_3 = { class: "chat-dialog__body" }
const _hoisted_4 = { class: "chat-dialog__body-header" }
const _hoisted_5 = { class: "chat-dialog__body-header-title" }
const _hoisted_6 = { class: "chat-dialog__body-header-datetime" }
const _hoisted_7 = {
  key: 0,
  class: "chat-dialog__body-message-logo",
  alt: "Avatar"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "chat-dialog__body-message-unreaded-count"
}

import { ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import DialogDeleteConfirm from "@/components/main/chat-panel/dropdowns/DialogDeleteConfirm.vue";
import moment from "moment/moment";
import { Dialog } from "@/store/chats";
import { highlightSearchText } from "@/utils/textHelpers";

type ChatDialogProps = {
	dialog: Dialog,
	fromSearch?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatDialog',
  props: {
    dialog: {},
    fromSearch: {}
  },
  emits: ["on-delete", "on-open"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $deleteDialog = ref<typeof AppResizableDropdown | null>(null)

const dialogDate = moment(props.dialog.MessageDate).format("DD.MM.YYYY HH:mm");

const onDeleteDialog = () => emit("on-delete", props.dialog.Id);
const onOpen = (event: MouseEvent) => {
	if ((event?.target as HTMLElement)?.closest('.link-message')) {
		return
	}
	emit("on-open", props.dialog)
};

return (_ctx: any,_cache: any) => {
  const _directive_img_fade = _resolveDirective("img-fade")!

  return (_openBlock(), _createElementBlock("div", {
    class: "chat-dialog",
    onClick: onOpen
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.dialog.PhotoLink)
        ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_2, null, 512)), [
            [_directive_img_fade, props.dialog.PhotoLink]
          ])
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({
					'chat-dialog__logo-text': true,
					'chat-dialog__logo-text--personal': props.dialog.IsPersonal
				})
          }, _toDisplayString(props.dialog.PhotoLiter), 3))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(props.dialog.Name), 1),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref(dialogDate)) + " ", 1),
          _createVNode(AppResizableDropdown, {
            ref_key: "$deleteDialog",
            ref: $deleteDialog,
            name: "$deleteDialog",
            position: "left",
            "max-width": 235,
            "close-by-click-outside": ""
          }, {
            activator: _withCtx(() => [
              _createVNode(AppTooltip, {
                class: "chat-dialog__body-header-tooltip",
                text: "Удалить",
                position: "right"
              }, {
                activator: _withCtx(() => [
                  (!props.fromSearch)
                    ? (_openBlock(), _createBlock(AppIcon, {
                        key: 0,
                        class: "chat-dialog__body-header-btn",
                        name: "close-bold",
                        size: "12px",
                        color: "#D2D2D2",
                        "hover-color": "#BA4C4C",
                        cursor: "pointer"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(DialogDeleteConfirm, {
                type: props.dialog.IsPersonal ? 'chat' : 'group',
                name: props.dialog.Name,
                onConfirm: onDeleteDialog,
                onCancel: _cache[0] || (_cache[0] = ($event: any) => ($deleteDialog.value.close()))
              }, null, 8, ["type", "name"])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({
				'chat-dialog__body-message': true,
				'chat-dialog__body-message--unreaded': props.dialog.Unreaded && !props.dialog.UnreadCount,
			})
      }, [
        (props.dialog.ShowSmallPhoto)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (props.dialog.SmallPhotoLink)
                ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_7, null, 512)), [
                    [_directive_img_fade, props.dialog.SmallPhotoLink]
                  ])
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass({
							'chat-dialog__body-message-text-logo': true,
							'chat-dialog__body-message-text-logo--personal': props.dialog.IsPersonal
						})
                  }, _toDisplayString(props.dialog.SmallPhotoLiter), 3))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({
						'chat-dialog__body-message-text': true
					}),
          innerHTML: 
						props.fromSearch
						? _unref(highlightSearchText)(props.fromSearch, props.dialog.Message)
						: props.dialog.Message.split('\n')[0]
					
        }, null, 8, _hoisted_8),
        (props.dialog.UnreadCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(props.dialog.UnreadCount), 1))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})